import { JSX } from "react"
import { localize } from "../../../../common/services/localization"
import { UpdateGroupTitleIcon } from "../../ui/icons"

export const UpdateGroupBlock: React.FC<{
    titleLocalName: string
    child: JSX.Element
    className?: string
    id?: string
}> = ({ titleLocalName, child, className, id }) => {
    return <div id={id ?? ''} className="gap-[22px]">
        <div className={`flex bg-updates-group-title h-[50px] `}>
            <UpdateGroupTitleIcon />
            <span className="text-gray-gradient py-[12px] px-[20px] lg:px-[60px] text-[16px] lg:text-[18px] font-bold uppercase font-['Reaver']">
                {localize(titleLocalName)}
            </span>
        </div>
        <div className={`${className}`}>
            {child}
        </div>
    </div>
}